import {InternalLinkOption} from "../option"
import {LexicalEditor} from "lexical"

import {PopoverMenuItemType} from "../../../../popover-menu/popover-menu/const"
import {EntitySelectorSettings} from "../../../editor"
import slashMenu_iconComponent from "./slah-menu-icon-component"
import {BUS_SLASH_MENU_SHOW_CHAT_WITH_AI} from "../@const"

export default function editor_aiOptions(editor: LexicalEditor, entitySelectorSettings: EntitySelectorSettings) {

    const writeWithAI = new InternalLinkOption('Write with AI', {
        id              : 'writeWithAI',
        type            : PopoverMenuItemType.CUSTOM_POPOVER,
        iconComponent   : slashMenu_iconComponent('i5-default-ai'),
        keywords        : ['write', 'with', 'ai'],
        action          : () => {
            gd.bus.triggerEvent(BUS_SLASH_MENU_SHOW_CHAT_WITH_AI)
        }
    })

    const options = [
        writeWithAI
    ]

    let optionsBlockKeywords: string[] = []
    _.map(options, option=>optionsBlockKeywords = optionsBlockKeywords.concat(option.keywords))

    return [
        new InternalLinkOption('AI', {
            type        : PopoverMenuItemType.HEADER,
            keywords    : optionsBlockKeywords
        }),

        ...options,

        /*new InternalLinkOption('', {
            type        : PopoverMenuItemType.SEPARATOR,
            keywords    : optionsBlockKeywords
        }),*/
    ]
}